/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechStorageUsbIcon16Light } from './TechStorageUsbIcon16Light';
import { TechStorageUsbIcon16Regular } from './TechStorageUsbIcon16Regular';
import { TechStorageUsbIcon16Solid } from './TechStorageUsbIcon16Solid';
import { TechStorageUsbIcon20Light } from './TechStorageUsbIcon20Light';
import { TechStorageUsbIcon20Regular } from './TechStorageUsbIcon20Regular';
import { TechStorageUsbIcon20Solid } from './TechStorageUsbIcon20Solid';
import { TechStorageUsbIcon24Regular } from './TechStorageUsbIcon24Regular';
import { TechStorageUsbIcon24Solid } from './TechStorageUsbIcon24Solid';
import { TechStorageUsbIcon32Regular } from './TechStorageUsbIcon32Regular';
import { TechStorageUsbIcon64Regular } from './TechStorageUsbIcon64Regular';
var sizes = {
    16: {
        light: TechStorageUsbIcon16Light,
        regular: TechStorageUsbIcon16Regular,
        solid: TechStorageUsbIcon16Solid,
    },
    20: {
        light: TechStorageUsbIcon20Light,
        regular: TechStorageUsbIcon20Regular,
        solid: TechStorageUsbIcon20Solid,
    },
    24: {
        regular: TechStorageUsbIcon24Regular,
        solid: TechStorageUsbIcon24Solid,
    },
    32: {
        regular: TechStorageUsbIcon32Regular,
    },
    64: {
        regular: TechStorageUsbIcon64Regular,
    },
};
export var TechStorageUsbIcon = forwardRef('TechStorageUsbIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
